import React, { useState } from "react";
import "../CardList/CardList.scss";
import "../../../../components/Search/Search.scss";
import "./TrainingCardList.scss";
import useTrainingCardList from "./logic/useTrainingCardList";
import AddCard from "../../../../components/AddCard/AddCard";
import ModalAddNewTraining from "./components/ModalAddNewTraining/ModalAddNewTraining";
import useAuth from "../../../../core/hooks/useAuth";
import TrainingCard from "../TrainingCard/TrainingCard";
import { checkUserRole } from "../../../../core/utils/helpers";
import { categories } from "../../../../data/Courses";
import Pagination from "../../../../components/Pagination/Pagination";

function TrainingCardList({ nameSection, isUpcomingTraining }) {
  const {
    data,
    meta,
    handleSearchChange,
    handleNext,
    handlePrevious,
    isModalOpen,
    setIsModalOpen,
    handleDeleteTraining,
    isModalEditOpen,
    setIsModaEditlOpen,
    isFetchingTraining,
    handlePageClick,
    handleCategoryChange,
    handleFetchAll

  } = useTrainingCardList(isUpcomingTraining);
  const { authenticatedUser } = useAuth();

  const openModal = () => {
    setIsModalOpen(true);
  };
  const [activeCategory, setActiveCategory] = useState("All");

  // Handle category click to filter courses
  const handleCategoryClick = (categoryText) => {
    handleCategoryChange({ target: { value: categoryText } }); 
    if (categoryText === "technique") {
      setActiveCategory("Technical skills");
    }else {

      setActiveCategory(categoryText);
    }
  };


  const startItem = (meta?.page - 1) * meta?.take + 1;
const endItem = Math.min(meta?.page * meta?.take, meta?.itemCount);
const totalItems = meta?.itemCount;

const displayText = `Showing ${startItem}–${endItem} of ${totalItems} results`;

  return (
    <div className="shop-page pb-130">
      <div className="row">
        <div className="col-lg-3 col-md-4 leftWidgetFiler">
          <div className="side-bar style-2">
            <div className="widget widget-search">
              <h4 className="title-widget">Search</h4>
              <div className="wg-search">
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="search-form relative"
                >
                  <fieldset className="search">
                    <input
                      type="search"
                      placeholder="Keywords"
                      className=""
                      name="search"
                      tabIndex={2}
                      defaultValue=""
                      aria-required="true"
                      required
                      onChange={handleSearchChange}
                    />
                  </fieldset>
                  <i className="icon-search" />
                </form>
              </div>
            </div>
            <div className="widget widget-categories">
              <h4 className="title-widget">Category</h4>
              <ul className="widget-categories">
                <li className={activeCategory === "All" ? "activeFilter" : ""}>
                  <div
                    className="cate-item"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveCategory("All");
                      handleFetchAll();
                    }}
                  >
                    <a href="#">All</a>
                  </div>
                  <i className="icon-arrow-right" />
                </li>
                {categories.map((category, index) => (
                  <li
                    key={index}
                    className={activeCategory === category.text ? "activeFilter" : ""}
                  >
                    <div
                      className="cate-item"
                      onClick={(e) => {
                        e.preventDefault();
                        const categoryText = category.text;
                        setActiveCategory(categoryText);
                        if (categoryText === "Technical skills") {
                          handleCategoryClick("technique");
                        } else {
                          handleCategoryClick(categoryText);
                        }
                      }}
                    >
                      <a href={category.link}>{category.text}</a>
                    </div>
                    <i className="icon-arrow-right" />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 rightWidgetList">
          <div className="shop-page-inner">
            <div className="flex items-center justify-between mb-40 z-23">
              <div className="text">{!isFetchingTraining && displayText}</div>
              <div className="dropdown" id="sort-by">
                <span className="btn-selector">
                  <span>
                    Sort by
                  </span>
                </span>

              </div>
            </div>
          </div>
          <div className="list-course">
            <div className="card-list">
          {checkUserRole(
            authenticatedUser,
            ["Admin", "Trainer"],
            <AddCard
              className="open-modal-button"
              Mode="Training"
              openModal={openModal}
            />
          )}
          <ModalAddNewTraining
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isUpcomingTraining={isUpcomingTraining}
          />
          {data?.map((card, index) => (
            <TrainingCard
              className="card"
              key={index}
              {...card}
              nameSection={nameSection}
              handleDeleteTraining={handleDeleteTraining}
              isModalEditOpen={isModalEditOpen}
              setIsModaEditlOpen={setIsModaEditlOpen}
              isUpcomingTraining={isUpcomingTraining}
            />
          ))}
        </div>
        </div>

          <div className="col-12">
            <div className="widget-pagination">
              <ul className="justify-center">
                <Pagination
                  className="pagination"
                  hasNextPage={meta.hasNextPage}
                  hasPreviousPage={meta.hasPreviousPage}
                  handleNext={handleNext}
                  handlePrevious={handlePrevious}
                  currentPage={meta?.page}
                  totalPageCount={meta?.pageCount}
                  handlePageClick={handlePageClick}
                />
              </ul>
            </div>
          </div>
    </div>
      </div>
    </div>
  );
}

export default TrainingCardList;
